module.exports = __webpack_public_path__ + "static/media/ip-valuation.538e909e.jpeg";